<dx-popup [visible]="visible" [showTitle]="false" [width]="'calc(100vw - 24px)'" [maxWidth]="960" [height]="'calc(100vh - 24px)'" [maxHeight]="680" [dragEnabled]="false" [hideOnOutsideClick]="false" [showCloseButton]="false" (onHiding)="close()">

	<div *dxTemplate="let _ of 'content'">
		<div class="popup-shell" data-cy="mapper-picklist-mapping-editor" (mapper-auto-match-and-apply)="autoMatchAndSaveFromEvent($event)">
			<div class="popup-header">
				<div class="popup-header-copy">
					<div class="popup-kicker">Picklist mapping</div>
					<h2>Map {{ sourceSystemName }} values to {{ targetSystemName }} values</h2>
					<p>Keep this list lean. Only map the source options that should resolve to a target picklist value.</p>
				</div>

				<button type="button" class="icon-btn" (click)="close()" aria-label="Close popup">×</button>
			</div>

			<div class="popup-context" *ngIf="row && sourceField">
				<div class="context-item">
					<span>{{ targetSystemName }} field</span>
					<strong>{{ row.targetDisplayName }}</strong>
				</div>
				<div class="context-item">
					<span>{{ sourceSystemName }} field</span>
					<strong>{{ sourceField.label }}</strong>
				</div>
				<div class="context-item">
					<span>{{ sourceSystemName }} options</span>
					<strong>{{ localItems.length }}</strong>
				</div>
			</div>

			<div class="popup-toolbar">
				<div class="popup-toolbar-actions">
					<dx-button text="Auto-match" stylingMode="contained" type="default" [elementAttr]="autoMatchButtonElementAttr" (onClick)="autoMatch()"></dx-button>
					<dx-button text="Clear" stylingMode="text" (onClick)="clearAll()"></dx-button>
				</div>

				<div class="mapping-filter" role="group" aria-label="Filter picklist mappings">
					<span>Show</span>
					<button type="button" [class.active]="viewFilter === 'all'" [attr.aria-pressed]="viewFilter === 'all'" (click)="setViewFilter('all')">Both <strong>{{ localItems.length }}</strong></button>
					<button type="button" [class.active]="viewFilter === 'mapped'" [attr.aria-pressed]="viewFilter === 'mapped'" (click)="setViewFilter('mapped')">Mapped <strong>{{ mappedItemCount }}</strong></button>
					<button type="button" [class.active]="viewFilter === 'unmapped'" [attr.aria-pressed]="viewFilter === 'unmapped'" (click)="setViewFilter('unmapped')">Unmapped <strong>{{ unmappedItemCount }}</strong></button>
				</div>
			</div>

			<div class="popup-grid-shell">
				<dx-data-grid [dataSource]="filteredItems" [height]="'100%'" [showBorders]="false" [hoverStateEnabled]="true" [rowAlternationEnabled]="false" [paging]="{ enabled: false }" [columnAutoWidth]="true" [wordWrapEnabled]="true" keyExpr="sourceValue">
					<dxo-scrolling mode="standard" [useNative]="true" showScrollbar="always"></dxo-scrolling>

					<dxi-column dataField="sourceValue" [caption]="sourceSystemName + ' value'" [allowEditing]="false" width="300"></dxi-column>
					<dxi-column dataField="sourceLabel" [caption]="sourceSystemName + ' label'" [allowEditing]="false" width="220"></dxi-column>
					<dxi-column [caption]="targetSystemName + ' value'" cellTemplate="targetValueTemplate" minWidth="320"></dxi-column>

					<div *dxTemplate="let cell of 'targetValueTemplate'">
						<dx-select-box [items]="targetOptions" displayExpr="label" valueExpr="value" [value]="cell.data.targetValue" (onValueChanged)="setTargetValue(cell.data, $event.value)" [searchEnabled]="true" [showClearButton]="true" [placeholder]="'Select ' + targetSystemName + ' value'">
						</dx-select-box>
					</div>
				</dx-data-grid>
			</div>

			<div class="popup-actions">
				<dx-button text="Cancel" stylingMode="text" (onClick)="close()"></dx-button>
				<dx-button text="Apply mapping" type="success" stylingMode="contained" [elementAttr]="applyMappingButtonElementAttr" (onClick)="save()"></dx-button>
			</div>
		</div>
	</div>
</dx-popup>
